
import { LockDec, ValidateDec } from "@/decorators";
import { TSX, Component, Prop, Vue } from 'vue-facing-decorator'

interface Props {
  /** 申请单，取自 returnList[].applicationInfo */
  data: any
  /** 1 同意、2 拒绝，对应 AuditReturnOrderDto.status */
  status: number
}

@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop({})
  data: any;

  @Prop({})
  status: number;

  submitLoading = false;

  postData = {
    returnAmount: "",
    replyMessage: "",
  }

  get isAgree() {
    return this.status == 1;
  }

  /** 买家勾选要退的货品，列表接口带了 applicationList.applicationGoodsList 才有 */
  get goodsList() {
    return this.data?.applicationGoodsList || [];
  }

  created() {
    this.postData.returnAmount = this.data?.amount || "";
  }

  /** 后端 @Min(0.01) + @IsNumber({maxDecimalPlaces:2})，这里先按同一口径挡一道 */
  validateAmount(v) {
    if (!this.isAgree) return;
    if (!v) throw '请输入退款金额';
    if (!/^\d*(\.\d{0,2})?$/.test(String(v))) throw '金额最多两位小数';
    if (Number(v) < 0.01) throw '退款金额必须大于0';
  }

  @ValidateDec("form")
  @LockDec("submitLoading")
  async submit() {
    let payload: any = {
      /** 注意这里要的是申请单 id，不是退款单 id */
      id: this.data.id,
      status: this.status,
      replyMessage: this.postData.replyMessage,
    };
    if (this.isAgree) {
      payload.returnAmount = Number(this.postData.returnAmount);
    }
    await this.$postNotify("/manager/order/audit-return-order", payload);
    this.$emit("resolve");
  }

  close() {
    this.$emit("reject", { msg: '取消' });
  }
}
